export default "__VITE_ASSET__DHQg3EpO__"